import { Physics, useSphere } from "@react-three/cannon";
import {  PerspectiveCamera, Sky, Stats, StatsGl } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { createContext, ReactElement, RefObject, useContext, useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { Light } from "./Light/Light";
import { Plane } from "./Plane/Plane";
import { VRPlayer } from "./VRPlayer/VRPlayer";
import { Button } from "components/Button/Button";
import { GlassesIcon, GlassWaterIcon } from "lucide-react";
import { AsyncProcess } from "services/AsyncProcess";
import { routes } from "routes";



// const XRstore = createXRStore()

interface CanvasContextType {
    camera?: RefObject<THREE.PerspectiveCamera | null>;
    doPlay?:boolean;
    setDoPlay?: React.Dispatch<React.SetStateAction<boolean>>;

    // orbitControls?:RefObject<any>;
}




const CanvasContext = createContext<CanvasContextType>({});



interface CanvasProviderProps extends WebSocketDataProps {
    className?: string
    isVR?: boolean
    hiddenPlayButton?:boolean;
    children?: any
    planeShowHelper?: boolean
    showSky?: boolean
    planeShow?: boolean
    onPlaneClick?: (Vector3: THREE.Vector3) => void
    helperMesh?: THREE.Mesh | null
    mapImgPath?: string
    planeScale?: [number, number, number]
    activePlaneHelper?: boolean
    camera?: { position?: [0, 0, 0] }
    onClickStartPlayer?:(e:boolean)=>void
    gW?:(e:string)=>string
  
}


export const CanvasProvider = ({ 
    className = " relative w-full h-full ", 
    showSky = true, 
    planeShow = true, 
    activePlaneHelper = true, 
    planeScale = [400, 400, 0], 
    isVR = true,
    gW,
    onClickStartPlayer,
    enableWebSocket,
    webSocketData,
    hiddenPlayButton=false,

    ...props 
}: CanvasProviderProps): ReactElement => {

    const camera = useRef<THREE.PerspectiveCamera | null>(null)

   
    // const orbitControls=useRef<any>(null); 
    const [doPlay,setDoPlay] = useState<boolean>(false);

    const [loading,setLoading] = useState<boolean>(false);

    const [avatarColors, setAvatarColors] = useState<Record<string, string>>({
        head: "#ffdbac",
        eyes: "#1a1a1a",
        torso: "#00f3ff",
        arms: "#00f3ff",
        legs: "#1a1a1a"
    });




    const values: CanvasContextType = {
        camera,
        doPlay,
        setDoPlay,
        // orbitControls,
    }



    
    const handelStartPlayer=()=>{

        AsyncProcess({
            url:routes.api.avatarColor,
            
            setError:()=>{
                onClickStartPlayer?.(!doPlay);
                setDoPlay(!doPlay);
            },
            effectProcess:[(res)=>{
                if(res?.success===false){
                  
                }else {
                    setAvatarColors(res?.data||undefined);

                }
                onClickStartPlayer?.(!doPlay);
                setDoPlay(!doPlay);
            }]
        })
      
    }





    return (<div className={className} >
        <CanvasContext.Provider value={values}>
            <Canvas 
                shadows
                className=" relative   "
                gl={{ powerPreference: "high-performance", antialias: true }}
            >
             
                {/* <StatsGl 
                    clearStatsGlStyle={true} 
                    trackGPU={true}      
                    minimal={false}      
                    horizontal={false}   
                    className="!absolute !top-16 !end-2" 
                /> */}

                <PerspectiveCamera ref={camera} makeDefault  position={props.camera?.position || [10, 1.7, 10]} />
                {/* <OrbitControls makeDefault  ref={orbitControls}  enableDamping  dampingFactor={0.1} /> */}
                {showSky && <Sky />}
                <Light type="directional" intensity={1} lookAt={[0, 0, 0]} position={[0, 100, 0]} />
                <Light type="directional" intensity={0.5} lookAt={[0, 0, 0]} position={[-100, 100, 0]} />
                <Light type="directional" intensity={0.5} lookAt={[0, 0, 0]} position={[100, 100, 0]} />
                <Light type="ambient" />
                <Physics gravity={[0, -9.81, 0]} tolerance={0.001} >
                    {props?.children}
                    {doPlay&&<VRPlayer 
                        colors={avatarColors}
                        enableWebSocket={enableWebSocket}
                        webSocketData={webSocketData}
                    />}
                    {planeShow && <Plane activeHelper={activePlaneHelper} material={{ color: props.mapImgPath ? "#fff" : "#f9fc51" }} mapImgPath={props.mapImgPath} helperMesh={props.helperMesh} onDoubleClick={props.onPlaneClick} showHelper={props.planeShowHelper} scale={planeScale} />}
                </Physics>


            </Canvas>
        </CanvasContext.Provider>
        {!hiddenPlayButton&& <div  
            className=" absolute z-[100px] bottom-4  w-full flex justify-center " 
        >
            <Button 
                
                variant="outline"
                className=" backdrop-blur "
                onClick={()=>{
                    handelStartPlayer();
                  
                }}  
            > 
                
                <GlassesIcon/>
                {doPlay ? gW?.("stop-tour"): gW?.("start-tour") } 
            </Button>
        </div>}
    </div>)
}








export const useCanvasContext = () => useContext(CanvasContext);